package team.platforma.multiplatform_material_extension.bottom_sheet.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember


@Composable
internal fun rememberSheetHelper(): SheetHelperInternal {
    return remember { SheetHelperImpl() }
}


internal interface SheetHelperInternal {
    fun close()
    fun addListener(listener: SheetHelper)
    fun removeListener(listener: SheetHelper)
}

interface SheetHelper {
    fun close()
}

private class SheetHelperImpl : SheetHelperInternal {
    private val listeners = mutableListOf<SheetHelper>()

    override fun close() {
        listeners.forEach { it.close() }
    }

    override fun addListener(listener: SheetHelper) {
        listeners.add(listener)
    }

    override fun removeListener(listener: SheetHelper) {
        listeners.remove(listener)
    }
}




